import Vue from "vue";
import VueRouter from "vue-router";
import Dashboard from "../views/Dashboard.vue";
// import Dinamica from '../views/Dinamica.vue'
// import Resultado from '../views/Resultado.vue'
// import MiCuenta from '../views/MiCuenta.vue'
// import Participaciones from '../views/Participaciones.vue'
import Aviso from "../views/Aviso.vue";
import LoginReportes from "../views/LoginReportes.vue";



Vue.use(VueRouter);

const routes = [
    // {
    //     path: '/',
    //     name: 'Dashboard',
    //     component: Dashboard,
    //     meta: {
    //         requiresAuth: true
    //     }
    // },
    {
        path: "/",
        name: "Home",
        component: () =>
            import ( /* webpackChunkName: "login" */ "../views/Home.vue"),
    },


    // {
    //     path: "/",
    //     name: "Registro",
    //     component: () =>
    //         import ( /* webpackChunkName: "login" */ "../views/Registro.vue"),
    // },
    // // {
    // //     path: "/:id",
    // //     name: "Registro",
    // //     component: () =>
    // //         import ( /* webpackChunkName: "login" */ "../views/Registro.vue"),
    // // },

    // // // {
    // // //     path: "/",
    // // //     name: "Login",
    // // //     component: () =>
    // // //         import ( /* webpackChunkName: "login" */ "../views/Login.vue"),
    // // // },
    {
        path: "/login",
        name: "Login",
        component: () =>
            import ( /* webpackChunkName: "login" */ "../views/Login.vue"),
    },

    // {
    //     path: "/agenda-aprobacion-xksj3",
    //     name: "Conferencias",
    //     component: () =>
    //         import ( /* webpackChunkName: "login" */ "../views/Conferencias.vue"),
    // },

    {
        path: "/agenda",
        name: "Conferencias",
        component: () =>
            import ( /* webpackChunkName: "login" */ "../views/Conferencias.vue"),
    },

    {
        path: "/patrocinadores",
        name: "Patrocinadores",
        component: () =>
            import ( /* webpackChunkName: "login" */ "../views/Patrocinadores.vue"),
    },

    // // // {
    // // //     path: "/mi-agenda",
    // // //     name: "MiAgenda",
    // // //     component: () =>
    // // //         import ( /* webpackChunkName: "login" */ "../views/MiAgenda.vue"),
    // // //     meta: {
    // // //         requiresUserAuth: true,
    // // //     },
    // // // },

    {
        path: "/qr-acceso",
        name: "QrAcceso",
        component: () =>
            import ( /* webpackChunkName: "login" */ "../views/QrAcceso.vue"),
        meta: {
            requiresUserAuth: true,
        },
    },

    {
        path: "/home-login",
        name: "HomeLogin",
        component: () =>
            import ( /* webpackChunkName: "login" */ "../views/Home.vue"),
        meta: {
            requiresUserAuth: true,
        },
    },

    {
        path: "/ponentes",
        name: "Ponentes",
        component: () =>
            import ( /* webpackChunkName: "login" */ "../views/Ponentes.vue"),
        meta: {
            requiresUserAuth: false,
        },
    },

    {
        path: "/mapa",
        name: "Mapa",
        component: () =>
            import ( /* webpackChunkName: "login" */ "../views/Mapa.vue"),
        meta: {
            requiresUserAuth: false,
        },
    },

    // // // {
    // // //     path: "/mapa/:id",
    // // //     name: "Mapa",
    // // //     component: () =>
    // // //         import ( /* webpackChunkName: "login" */ "../views/Mapa.vue"),
    // // //     meta: {
    // // //         requiresUserAuth: true,
    // // //     },
    // // // },

    // // // // // // // // // // {
    // // // // // // // // // //     path: "/networking",
    // // // // // // // // // //     name: "Networking",
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ "../views/Networking.vue"),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresUserAuth: true,
    // // // // // // // // // //     },
    // // // // // // // // // // },


    // // // // // // // // // // {
    // // // // // // // // // //     path: "/networking/conectar",
    // // // // // // // // // //     name: "Networking",
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ "../views/NetworkingConectar.vue"),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresUserAuth: true,
    // // // // // // // // // //     },
    // // // // // // // // // // },

    // // // // // // // // // // {
    // // // // // // // // // //     path: "/networking/conectar/:id",
    // // // // // // // // // //     name: "Networking",
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ "../views/NetworkingConectarUsuario.vue"),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresUserAuth: true,
    // // // // // // // // // //     },
    // // // // // // // // // // },

    // // // // // // // // // // {
    // // // // // // // // // //     path: "/networking/vcard/:id",
    // // // // // // // // // //     name: "Networking",
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ "../views/NetworkingConectarVCardUsuario.vue"),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresUserAuth: true,
    // // // // // // // // // //     },
    // // // // // // // // // // },



    // // // // // // // // // // {
    // // // // // // // // // //     path: "/networking/buzon",
    // // // // // // // // // //     name: "Networking",
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ "../views/NetworkingBuzon.vue"),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresUserAuth: true,
    // // // // // // // // // //     },
    // // // // // // // // // // },

    // // // // // // // // // // {
    // // // // // // // // // //     path: "/networking/edicion",
    // // // // // // // // // //     name: "Networking Edicion",
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ "../views/NetworkingEdicion.vue"),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresUserAuth: true,
    // // // // // // // // // //     },
    // // // // // // // // // // },

    // // // // // // // // // // {
    // // // // // // // // // //     path: "/networking/buzon/:id",
    // // // // // // // // // //     name: "Networking",
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ "../views/NetworkingBuzonDetalle.vue"),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresUserAuth: true,
    // // // // // // // // // //     },
    // // // // // // // // // // },

    // {
    //     path: "/sorteo/",
    //     name: "Sorteo",
    //     component: () =>
    //         import ( /* webpackChunkName: "login" */ "../views/Sorteo.vue"),
    //     meta: {
    //         requiresUserAuth: true,
    //     },
    // },

    // // // // // // // // {
    // // // // // // // //     path: "/sorteo/scan",
    // // // // // // // //     name: "SorteoScan",
    // // // // // // // //     component: () =>
    // // // // // // // //         import ( /* webpackChunkName: "login" */ "../views/SorteoScan.vue"),
    // // // // // // // //     meta: {
    // // // // // // // //         requiresUserAuth: true,
    // // // // // // // //     },
    // // // // // // // // },

    // // // // // // // // {
    // // // // // // // //     path: "/sorteo/scan/:id",
    // // // // // // // //     name: "SorteoScan",
    // // // // // // // //     component: () =>
    // // // // // // // //         import ( /* webpackChunkName: "login" */ "../views/SorteoScan.vue"),
    // // // // // // // //     meta: {
    // // // // // // // //         requiresUserAuth: true,
    // // // // // // // //     },
    // // // // // // // // },



    {
        path: "/faqs",
        name: "Preguntas",
        component: () =>
            import ( /* webpackChunkName: "login" */ "../views/Preguntas.vue"),
    },


    // {
    //     path: '/verificacion/:id/:codigo',
    //     name: 'Verificacion',
    //     component: () =>
    //         import ( /* webpackChunkName: "login" */ '../views/Verificacion.vue')
    // },
    // {
    //     path: '/ganadores',
    //     name: 'Ganadores',
    //     component: () =>
    //         import ( /* webpackChunkName: "login" */ '../views/Ganadores.vue')
    // },
    // // // {
    // // //     path: "/",
    // // //     name: "Administrador",
    // // //     component: LoginReportes,
    // // // },
    {
        path: "/administrador",
        name: "Administrador",
        component: LoginReportes,
    }, {
        path: "/administrador/dashboard",
        name: "Informe",
        component: () =>
            import ( /* webpackChunkName: "login" */ "../views/ReportesInforme.vue"),
        meta: {
            requiresAuth: true,
        },
    }, {
        path: "/administrador/edicion-registro/:id",
        name: "Informe",
        component: () =>
            import ( /* webpackChunkName: "login" */ "../views/AdminEdicionRegistro.vue"),
        meta: {
            requiresAuth: true,
        },
    }, {
        path: "/administrador/registro",
        name: "RegistroAdmin",
        component: () =>
            import ( /* webpackChunkName: "login" */ "../views/RegistroAdmin.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    // // // // // // // // // // {
    // // // // // // // // // //     path: "/administrador/sorteo",
    // // // // // // // // // //     name: "SorteoAdmin",
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ "../views/SorteoAdmin.vue"),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresAuth: true,
    // // // // // // // // // //     },
    // // // // // // // // // // },
    {
        path: '/lector',
        name: 'LoginLector',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/LoginLector.vue'),
    }, {
        path: '/lector/dashboard',
        name: 'DashboardLector',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/DashboardLector.vue'),
        meta: {
            requiresAuthAdmin: true
        }
    }, {
        path: '/lector/scan',
        name: 'ScanLector',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/ReportesLector.vue'),
        meta: {
            requiresAuthAdmin: true
        }
    }, {
        path: '/lector/email',
        name: 'EmailLector',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/ReportesLectorEmail.vue'),
        meta: {
            requiresAuthAdmin: true
        }
    },
    // // // // // // // // // // {
    // // // // // // // // // //     path: '/lector/conferencias',
    // // // // // // // // // //     name: 'ConferenciasLector',
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ '../views/ConferenciasLector.vue'),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresAuthAdmin: true
    // // // // // // // // // //     }
    // // // // // // // // // // },
    // // // // // // // // // // {
    // // // // // // // // // //     path: '/lector/networking',
    // // // // // // // // // //     name: 'NetworkingLector',
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ '../views/NetworkingLector.vue'),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresAuthAdmin: true
    // // // // // // // // // //     }
    // // // // // // // // // // },
    // {
    //     path: '/lector/registro',
    //     name: 'RegistroLector',
    //     component: () =>
    //         import ( /* webpackChunkName: "login" */ '../views/RegistroLector.vue'),
    //     meta: {
    //         requiresAuthAdmin: true
    //     }
    // },
    {
        path: '/lector/impresion/:id',
        name: 'ImpresionLector',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/RegistroImpresion.vue'),
        meta: {
            requiresAuthAdmin: true
        }
    }, {
        path: "/aviso-de-privacidad",
        name: "aviso",
        component: Aviso,
    },
    // {
    //     path: '/:id',
    //     name: 'Login',
    //     component: () =>
    //         import ( /* webpackChunkName: "login" */ '../views/Login.vue')
    // }
];

const router = new VueRouter({
    mode: "history",
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash,
            };
        }
        return { x: 0, y: 0 };
    },
    base: process.env.BASE_URL,
    routes,
});

// navigation guard to check for logged in users
router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some((x) => x.meta.requiresAuth);
    const requiresUserAuth = to.matched.some((x) => x.meta.requiresUserAuth);
    const requiresAuthAdmin = to.matched.some((x) => x.meta.requiresAuthAdmin);

    const requiresNoTicket = to.matched.some((x) => x.meta.requiresNoTicket);
    const requiresTicket = to.matched.some((x) => x.meta.requiresTicket);

    let user;

    if (requiresAuth) {
        user = localStorage.getItem("user_foroprosa_2023");
        user = JSON.parse(user);
        console.log(user);
    } else if (requiresAuthAdmin) {
        user = localStorage.getItem("user_foroprosa_2023_lector");
        user = JSON.parse(user);
        console.log(user);
    } else if (requiresUserAuth) {
        user = localStorage.getItem("user_foroprosa_2023");
        user = JSON.parse(user);
        console.log({ userauth: user });
    }

    if (requiresAuth === true && (user == null || user == undefined)) {
        next("/administrador");
    } else if (requiresAuthAdmin === true && (user == null || user == undefined)) {
        next("/lector");
    } else if (requiresUserAuth == true && (user == null || user == undefined)) {
        //console.log('direccionando usuario')
        next("/login");
    } else {
        // if (user != null && requiresAuth == true) {
        //     next('/administrador/dashboard')
        // } else if (user != null && requiresAuthAdmin == true) {
        //     next('/lector/scan')
        // }

        next();
    }
});

export default router;